import { BeltSyllabus } from './types';

export const whiteBelt: BeltSyllabus = {
  id: 'white',
  name: 'White Belt',
  color: '#ffffff', // White
  theoryUnder13: [
    {
      title: 'Theory',
      items: [
        {
          question: 'Who was the father and founder of Taekwon-Do?',
          answer: 'Grandmaster General Choi Hong Hi, 9th Dan'
        },
        {
          question: 'Note',
          answer: 'Note that "Choi Hong Hi" is pronounced as "Chey Hong Hee"',
          note: 'italic'
        },
        {
          question: 'What does the colour of the white belt mean?',
          answer: 'White signifies innocence'
        },
        {
          question: 'Which country does Taekwon-Do come from?',
          answer: 'Korea'
        },
        {
          question: 'When was Taekwon-Do born?',
          answer: '11th April 1955'
        },
        {
          question: 'What is the first tenet of Taekwon-Do?',
          answer: 'Courtesy'
        },
        {
          question: 'What does courtesy mean?',
          answer: 'To be polite, to behave with manners and to respect others'
        }
      ]
    },
    {
      title: 'Korean Terms',
      items: [
        { question: 'Stance', answer: 'Sogi' },
        { question: 'Punch', answer: 'Jirugi' },
        { question: 'Kick', answer: 'Chagi' },
        { question: 'Block', answer: 'Makgi' },
        { question: 'Attention Stance', answer: 'Charyot Sogi' },
        { question: 'Parallel Stance', answer: 'Narani Sogi' },
        { question: 'Walking Stance', answer: 'Gunnun Sogi' },
        { question: 'Sitting Stance', answer: 'Annun Sogi' },
        { question: 'Front Kick', answer: 'Ap Chagi' },
        { question: 'Downward Kick', answer: 'Naeryo Chagi' }
      ]
    }
  ],
  theoryOver13: [
    {
      title: 'Theory',
      items: [
        {
          question: 'Who was the father and founder of Taekwon-Do?',
          answer: 'Grandmaster General Choi Hong Hi, 9th Dan'
        },
        {
          question: 'Note',
          answer: 'Note that "Choi Hong Hi" is pronounced as "Chey Hong Hee"',
          note: 'italic'
        },
        {
          question: 'What does the colour of the white belt mean?',
          answer: 'White signifies innocence, as the beginner who has no previous knowledge of Taekwon-Do'
        },
        {
          question: 'When was Taekwon-Do officially founded?',
          answer: '11th April 1955'
        },
        {
          question: 'What are the five tenets of Taekwon-Do?',
          answer: 'Courtesy, Integrity, Perseverance, Self-Control, Indomitable Spirit'
        },
        {
          question: 'Describe the three sections of the body and what they are called',
          answer: [
            'High (Nopundae) - neck and head',
            'Middle (Ka-un-dae) - belt to neck',
            'Low (Najundae) - below the belt'
          ]
        }
      ]
    },
    {
      title: 'Korean Terms',
      items: [
        { question: 'Stance', answer: 'Sogi' },
        { question: 'Punch', answer: 'Jirugi' },
        { question: 'Kick', answer: 'Chagi' },
        { question: 'Block', answer: 'Makgi' },
        { question: 'Thrust', answer: 'Tulgi' },
        { question: 'Attention Stance', answer: 'Charyot Sogi' },
        { question: 'Parallel Stance', answer: 'Narani Sogi' },
        { question: 'Parallel Ready Stance', answer: 'Narani Junbi Sogi' },
        { question: 'Walking Stance', answer: 'Gunnun Sogi' },
        { question: 'Walking Ready Stance', answer: 'Gunnun Junbi Sogi' },
        { question: 'Sitting Stance', answer: 'Annun Sogi' },
        { question: 'Forefist', answer: 'Ap Joomok' },
        { question: 'Knifehand', answer: 'Sonkal' },
        { question: 'Inner Forearm', answer: 'An Palmok' },
        { question: 'Outer Forearm', answer: 'Bakat Palmok' },
        { question: 'Back Heel', answer: 'Dwitchook' },
        { question: 'Ball of the Foot', answer: 'Ap Kumchi' }
      ]
    }
  ],
  practical: [
    {
      title: 'Practical Elements',
      items: [
        {
          question: 'Sitting Stance Middle Punch',
          answer: 'X 10'
        },
        {
          question: 'Low Front Snap Kick, Walking Ready Stance',
          answer: 'Forward X 4'
        },
        {
          question: 'Walking Stance Inner Forearm Middle Block',
          answer: 'Backward X 4'
        },
        {
          question: 'Walking Stance Middle Punch',
          answer: 'Forward X 4'
        },
        {
          question: 'Walking Stance Outer Forearm Low Block',
          answer: 'Backward X 4'
        },
        {
          question: 'Walking Stance Outer Forearm High Block',
          answer: 'Forward X 4'
        },
        {
          question: 'Walking Stance Outer Forearm Rising Block',
          answer: 'Backward X 4'
        }
      ]
    },
    {
      title: 'Power',
      items: [
        {
          question: 'Front Kick',
          answer: 'Target / Kick Shield'
        },
        {
          question: 'Downward kick',
          answer: 'Target / Kick Shield'
        }
      ]
    },
    {
      title: 'Pattern',
      items: [
        {
          question: 'Saju Jirugi',
          answer: ' '
        }
      ]
    },
    {
      title: 'Self Defence',
      items: [
        {
          question: 'Wrist Hold - Rotational Release',
          answer: "Under 13's"
        },
        {
          question: 'Avoid being Grabbed / Pushed (1 or 2 hands from attacker)',
          answer: 'All Ages'
        },
        {
          question: 'Situational - Intimidating Position',
          answer: 'All Ages'
        }
      ]
    },
    {
      title: 'Sparring',
      items: [
        {
          question: 'Free Sparring',
          answer: 'Looking for Movement'
        }
      ]
    }
  ]
};
